const { register, submitGuest } = require("coremh/components/loginHelpers");
var addressAutocomplete = require("google/autocomplete");

/**
* Registers a user with their birthday information.
* This function calls the register function with a parameter indicating that the birthday should be included.
*/
function registerWithBirthday() {
    register(true);
}

function initGoogleAutocomplete() {
    addressAutocomplete.initAutocomplete();
}

module.exports = {
    register: registerWithBirthday,
    submitGuest: submitGuest,
    initGoogleAutocomplete: initGoogleAutocomplete
};
